export default {
    ADD_ASSETS: 'ADD_ASSETS',
    ADD_ASSET: 'ADD_ASSET',
    RESET_ASSETS: 'RESET_ASSETS',
    UPDATE_FULL_ASSETS: 'UPDATE_FULL_ASSETS'
  };
  